module.exports = __webpack_public_path__ + "static/img/land.b942d26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/land.png
// module id = V4OJ
// module chunks = 1